/**
 * @file index.js
 * @author Alvaro Martinez
 * @description Initialize Proteinuria Details List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ProteinuriaDetailListView';

export const mapStateToPropsProteinuriaDetailsList = mapStateToProps;
export const mapDispatchToPropsProteinuriaDetailsList = mapDispatchToProps;

export default connect(
  mapStateToPropsProteinuriaDetailsList,
  mapDispatchToPropsProteinuriaDetailsList
)(View);
